import { Message } from "primereact/message";
import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";

import { actionTooltipProps, Icon, RadioGroup } from "@/ds";
import tabela from "../planejamento-controle.tabela.module.scss";
import styles from "./etapa-destino-transferencia.module.scss";
import type { EtapaDestinoTransferenciaViewModel } from "./types-etapa-destino-transferencia";

export function EtapaDestinoTransferenciaView({
  titulo,
  subtitulo,
  aviso,
  ariaLabel,
  cabecalhos,
  colunaId,
  colunaSituacao,
  linhas,
  selecionadaId,
  selecionar,
  clicarLinha,
  testIds,
  children,
}: EtapaDestinoTransferenciaViewModel) {
  return (
    <section className={styles.etapa} data-testid={testIds.etapa}>
      <header className={styles.cabecalho}>
        <h3 className={styles.titulo}>{titulo}</h3>
        <p className={styles.subtitulo}>{subtitulo}</p>
      </header>
      <Message
        severity="info"
        className="p-message-simple p-message-block"
        icon={<Icon name="info-circle" size={18} />}
        text={aviso}
        data-testid={testIds.aviso}
      />

      <RadioGroup.Root
        value={selecionadaId}
        onChange={(valor) => selecionar(String(valor))}
        aria-label={ariaLabel}
        testId={testIds.obras}
      >
        <div className={tabela.tabelaWrap}>
          <table className={tabela.tabela}>
            <thead>
              <tr>
                <th scope="col">{colunaId}</th>
                {cabecalhos.map((cabecalho) => (
                  <th key={cabecalho} scope="col">
                    {cabecalho}
                  </th>
                ))}
                <th scope="col">{colunaSituacao}</th>
              </tr>
            </thead>
            <tbody>
              {linhas.map((linha) => (
                <tr
                  key={linha.id}
                  className={linha.disponivel ? styles.clicavel : styles.indisponivel}
                  onClick={(evento) => clicarLinha(linha, evento)}
                  data-testid={linha.testIds.linha}
                >
                  <td>
                    <RadioGroup.Item
                      value={linha.id}
                      label={linha.codigo}
                      disabled={!linha.disponivel}
                      testId={linha.testIds.radio}
                    />
                  </td>
                  {linha.celulas.map((celula, indice) => (
                    <td key={cabecalhos[indice]}>
                      {celula.etiqueta ? (
                        <Tag value={celula.valor} severity="info" />
                      ) : (
                        celula.valor
                      )}
                    </td>
                  ))}
                  <td className={styles.situacao}>
                    <Tag
                      value={linha.situacao}
                      className={linha.situacaoTitulo ? styles.situacaoComMotivo : undefined}
                      data-pr-tooltip={linha.situacaoTitulo}
                      severity={linha.disponivel ? "success" : "secondary"}
                      data-testid={linha.testIds.situacao}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </RadioGroup.Root>

      <Tooltip target={`.${styles.situacaoComMotivo}`} {...actionTooltipProps("")} />

      {children}
    </section>
  );
}
